export interface Slide_data {
    id : number;

    title : string;

    imgurl : string;

    content : string;

    tag : string;

    tag2 : string;
}

let data:Slide_data[] = [
    {
        id : 0,
        title : '유니크 끝판왕 데님',
        imgurl : './img/main_new_00.png',
        content : '이런 워싱 본 적 있어?',
        tag : '#NEW',
        tag2 : '#DENIM'
    },
    {
        id : 1,
        title : '득템 2PACK',
        imgurl : './img/main_new_01.png',
        content : '믿고 가는 그래픽',
        tag : '#NEW',
        tag2 : '#DENIM'
    },
    {
        id : 2,
        title : '핑크 숏팬츠',
        imgurl : './img/main_new_02.png',
        content : '색감에 취한다..',
        tag : '#NEW',
        tag2 : '#DENIM'
    },
    {
        id : 3,
        title : '반팔 패키지',
        imgurl : './img/main_new_03.png',
        content : '인기가 식지를 않아',
        tag : '#NEW',
        tag2 : '#DENIM'
    },
    {
        id : 4,
        title : '상큼해~',
        imgurl : './img/main_new_04.png',
        content : '보기만해도',
        tag : '#NEW',
        tag2 : '#DENIM'
    },
    {
        id : 5,
        title : '써머 데님셔츠',
        imgurl : './img/main_new_05.png',
        content : '감성이 가득해',
        tag : '#NEW',
        tag2 : '#DENIM'
    },
]

export default data;